import { DraftState } from '@/types';
import { DraftActionTypes, SetDraftAction } from '../types';

export const setReduxDraftAction = (draft: DraftState): SetDraftAction => ({
  type: DraftActionTypes.SET_DRAFT,
  draft,
});
